export default __webpack_public_path__ + "static/media/IMG_5553.5745d6bc.jpg";